import { UserOnboardingModel } from '../../models/onboarding/user-onboarding-model'

export interface UserOnboarding {
  get(): Promise<UserOnboarding.Model>
}

export namespace UserOnboarding {
  export type Model = UserOnboardingModel
  export const KeyGet = 'user-onboarding'
}
